import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { LibInputInterface } from '../../models/input.interface';

@Component({
  selector: 'lib-date-input',
  templateUrl: './lib-date-input.component.html',
  styleUrls: ['./lib-date-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibDateInputComponent implements LibInputInterface {
  @Input() dayControl: UntypedFormControl;
  @Input() monthControl: UntypedFormControl;
  @Input() yearControl: UntypedFormControl;
  @Input() errorMessage: string;
  @Input() labelId: string;
  @Input() labelText: string;
  @Input() isDateValid: boolean;
  @Input() spellcheck? = false;

  get formTouchedAndInvalid(): boolean {
    return (
      (this.dayControl.touched && !this.dayControl.valid) ||
      (this.monthControl.touched && !this.monthControl.valid) ||
      (this.yearControl.touched && !this.yearControl.valid) ||
      (this.dayControl.value?.length == 2 &&
        this.monthControl.value?.length == 2 &&
        this.yearControl.value?.length == 4 &&
        !this.isDateValid &&
        (this.yearControl.touched || this.monthControl.touched || this.dayControl.touched))
    );
  }

  updateSingleDigit(control: UntypedFormControl): void {
    if (control.value?.length === 1 && control.value !== '0') {
      control.setValue('0' + control.value);
    }
  }

  removeStrings(control: UntypedFormControl): void {
    control.setValue(control.value?.replace(/\D/g, ''));
  }

  get formTouchedAndValid(): boolean {
    return (
      this.dayControl.valid &&
      this.monthControl.valid &&
      this.yearControl.valid &&
      this.isDateValid &&
      (this.yearControl.touched || this.monthControl.touched || this.dayControl.touched)
    );
  }
}
